import { render } from "./create.vue?vue&type=template&id=ab34b6f6"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=ab34b6f6&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__